/*
 * Purpose: Compose plan section row — matches Builder activity card styling
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import type { ReactNode } from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface ComposePlanRowCardProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function ComposePlanRowCard({
  title,
  description,
  icon,
  action,
  children,
  className,
  contentClassName,
}: ComposePlanRowCardProps) {
  return (
    <Card className={cn('p-3 sm:p-4 ui-lift-card-subtle border-border/60', className)}>
      <div className="flex items-start gap-2">
        {icon && (
          <div className="shrink-0 mt-0.5 text-muted-foreground [&_svg]:h-4 [&_svg]:w-4">{icon}</div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold leading-tight">{title}</p>
          {description && (
            <p className="text-[10px] sm:text-xs text-muted-foreground mt-0.5 leading-snug">{description}</p>
          )}
        </div>
        {action && <div className="shrink-0 ml-auto">{action}</div>}
      </div>
      {children && <div className={cn('mt-3', contentClassName)}>{children}</div>}
    </Card>
  );
}
